// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Bonaire from '../_raw/flag/icon_flag_bonaire.png';

export default () => <img src={Bonaire} alt="Bonaire" />;
